import Student from "@/data/userTypes/Student";
import Experienced from "@/data/userTypes/Experienced";

export default {
  getType: (typeName) => {
    switch (typeName) {
      case 'student':
        return Student
      default:
        return Experienced
    }
  }
}
